export enum ECalendarDoorTypes {
  CONTENT = `content`,
  GIVEAWAY = `giveaway`,
  PRODUCT = `product`,
}
